<style>
  .icon-container .pi-chevron-right {
    transition: transform 0.2s ease-in-out;
  }

  .icon-container .pi-chevron-right.rotated {
    transform: rotate(90deg);
  }
</style>

<!-- A popup dialog to select a different brand -->
<app-choose-brand [displayBrandDialog]="openBrandSelectionDialog"
  (chooseBrandEvent)="chooseBrand($event)"></app-choose-brand>

<!--- Generic header, inclusing current brand andd a button to select another brand -->

<div class="grid">
  <div class="col-6">
    <app-brand-admin-header></app-brand-admin-header>
  </div>
  <div class="col-1">
    <button pButton type="button" label="Brand" icon="pi pi-sitemap" iconPos="left" (click)="onChooseBrandClick($event)"
      class="p-button-raised p-button-rounded" [disabled]="isDetailsShown">
    </button>
  </div>
  <app-side-menu [parentForm]="currentForm"></app-side-menu>
</div>


<!-- This makes the page in center -->
<div class="grid justify-content-center">

  <!--- First card with the master list -->

  <div  class="col-12 side-list-content-data"
    *ngIf="configPresent === 'present' || configPresent === 'absent' ">
    <p-card header="Bootstrap" subheader="" class="ui-card-light" *ngIf="configPresent === 'absent' ">
      <!-- Bootstrap with default values -->
      <div class="card mb-2">
        <div class="card-body">
          <button type="button" class="btn btn-primary mb-2" (click)="bootstrapDefaultEvConfigIfAbsent()">Create with
            default values</button>
        </div>
      </div>
    </p-card>
    <p-card header="Ev Configuration ({{currentBrand.brandCode}}) - {{configData.changeDescription}}" subheader=""
      class="ui-card-light" *ngIf="configPresent === 'present' ">

      <!-- EV Fields Section -->
      <div class="card mb-0">
        <div class="card-header d-flex justify-content-between align-items-center" (click)="toggleSection('evFields')"
          style="cursor:pointer;">
          <div class="d-flex align-items-center">
            <h5 class="m-0 d-flex align-items-center">
              <span class="icon-container me-2">
                <i class="pi pi-chevron-right" [class.rotated]="!evFieldsCollapsed"></i>
              </span>
              Ev Fields
            </h5>
            <i class="pi pi-info-circle ms-2 text-dark" title="Ev Fields: "></i>
          </div>
          <button type="button" class="btn btn-success btn-sm" (click)="addNewField(); $event.stopPropagation()">+ Add
            New Field</button>
        </div>
        <div *ngIf="!evFieldsCollapsed">
          <div class="card-body subtab">
            <div *ngIf="!configData.evFields.length" class="text-center text-muted">No fields defined.</div>
            <div *ngFor="let field of configData.evFields; let i = index" class="card bg-light mb-2 ms-4">
              <div class="card-header-subsection d-flex justify-content-between align-items-center"
                (click)="toggleFieldCollapse(field)" style="cursor:pointer;">
                <div class="d-flex align-items-center">
                  <span class="icon-container me-2">
                    <i class="pi pi-chevron-right" [class.rotated]="!field.collapsed"></i>
                  </span>
                  <strong>Field: {{ field.fieldName || 'New Field' }}</strong>
                </div>

                <!-- Action Buttons Group -->
                <div class="d-flex align-items-center">
                  <button type="button" class="btn btn-outline-secondary btn-sm me-2"
                    (click)="moveFieldUp(i); $event.stopPropagation()" [disabled]="i === 0" title="Move Up">
                    <i class="pi pi-arrow-up"></i>
                  </button>
                  <button type="button" class="btn btn-outline-secondary btn-sm me-2"
                    (click)="moveFieldDown(i); $event.stopPropagation()"
                    [disabled]="i === configData.evFields.length - 1" title="Move Down">
                    <i class="pi pi-arrow-down"></i>
                  </button>
                  <button type="button" class="btn btn-danger btn-sm"
                    (click)="removeField(i); $event.stopPropagation()">Remove</button>
                </div>
              </div>
              <div class="card-body" *ngIf="!field.collapsed">
                <div class="row">
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Field Name</label></div>
                      <div class="col-md-6"><input type="text" class="form-control" [(ngModel)]="field.fieldName"
                          [name]="'fieldName' + i"></div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Label</label></div>
                      <div class="col-md-6"><input type="text" class="form-control" [(ngModel)]="field.label"
                          [name]="'label' + i"></div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Placeholder</label></div>
                      <div class="col-md-6"><input type="text" class="form-control" [(ngModel)]="field.placeholder"
                          [name]="'placeholder' + i"></div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Input Type</label></div>
                      <div class="col-md-6">
                        <select class="form-control" [(ngModel)]="field.inputType" [name]="'inputType' + i">
                          <option *ngFor="let type of inputTypes" [value]="type">{{type}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Validation Pattern (Regex)</label></div>
                      <div class="col-md-6"><input type="text" class="form-control"
                          [(ngModel)]="field.pattern" [name]="'pattern' + i"></div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Max Length</label></div>
                      <div class="col-md-6"><input type="number" class="form-control" [(ngModel)]="field.maxLength"
                          [name]="'maxLength' + i"></div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Field Value Comparison</label></div>
                      <div class="col-md-6">
                        <select class="form-control" [(ngModel)]="field.fieldValueComparisonType"
                          [name]="'comparisonType' + i">
                          <option *ngFor="let type of comparisonTypes" [value]="type">{{type}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Invalid Format Message</label></div>
                      <div class="col-md-6"><input type="text" class="form-control" [(ngModel)]="field.invalidFormatMsg"
                          [name]="'invalidFormatMsg' + i"></div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Mask</label></div>
                      <div class="col-md-6"><input type="text" class="form-control" [(ngModel)]="field.mask"
                          [name]="'mask' + i"></div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row align-items-center">
                      <div class="col-md-6"><label class="form-label mb-0">Data Type</label></div>
                      <div class="col-md-6">
                        <select class="form-control" [(ngModel)]="field.dataType" [name]="'dataType' + i">
                          <option *ngFor="let dataType of dataTypes" [value]="dataType">{{dataType}}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Show More/Less link -->
                  <div class="col-md-12 mt-2">
                    <a href="javascript:void(0)" (click)="toggleShowMore(field)">
                      {{ field.showMore ? 'Show less <<' : 'Show more >>' }} </a>
                  </div>

                  <!-- Hidden sections -->
                  <div *ngIf="field.showMore" class="col-md-12 mt-2">
                    <div class="card">
                      <div class="card-header-subsection card-header-subsection-alt">Additional Attibutes</div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-3">
                            <div class="row align-items-center">
                              <div class="col-md-6"><label class="form-label mb-0">Default Value</label></div>
                              <div class="col-md-6"><input type="text" class="form-control"
                                  [(ngModel)]="field.defaultValue" [name]="'defaultValue' + i"></div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="row align-items-center">
                              <div class="col-md-6"><label class="form-label mb-0">Origin Variable Name</label></div>
                              <div class="col-md-6"><input type="text" class="form-control"
                                  [(ngModel)]="field.originVariableName" [name]="'originVariableName' + i"></div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="row align-items-center">
                              <div class="col-md-6"><label class="form-label mb-0">Pad Char</label></div>
                              <div class="col-md-6"><input type="text" class="form-control" [(ngModel)]="field.padChar"
                                  [name]="'padChar' + i"></div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="row align-items-center">
                              <div class="col-md-6"><label class="form-label mb-0">Padded Size</label></div>
                              <div class="col-md-6"><input type="number" class="form-control"
                                  [(ngModel)]="field.paddedSize" [name]="'paddedSize' + i"></div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="row align-items-center">
                              <div class="col-md-6"><label class="form-label mb-0">Transform Format Pattern</label>
                              </div>
                              <div class="col-md-6"><input type="text" class="form-control"
                                  [(ngModel)]="field.transformFormatPattern" [name]="'transformFormatPattern' + i">
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="field.accountIdentity"
                                [name]="'accountIdentity' + i">
                              <label class="form-check-label">Account Identity</label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox"
                                [(ngModel)]="field.secondaryAccountIdentity" [name]="'secondaryAccountIdentity' + i">
                              <label class="form-check-label">Secondary Account Identity</label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="field.ignoredIfProvided"
                                [name]="'ignoredIfProvided' + i" disabled>
                              <label class="form-check-label">Ignored If Provided</label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="field.displayed"
                                [name]="'displayed' + i">
                              <label class="form-check-label">Displayed</label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="field.leftPadded"
                                [name]="'leftPadded' + i">
                              <label class="form-check-label">Left Padded</label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="field.rightPadded"
                                [name]="'rightPadded' + i">
                              <label class="form-check-label">Right Padded</label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="field.aliased"
                                [name]="'aliased' + i">
                              <label class="form-check-label">Aliased</label>
                              
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="field.persisted"
                                [name]="'persisted' + i">
                              <label class="form-check-label">Persisted</label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="field.uppercase"
                                [name]="'uppercase' + i">
                              <label class="form-check-label">Uppercase</label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" [(ngModel)]="field.useTextBox"
                                [name]="'useTextBox' + i">
                              <label class="form-check-label">Use Text Box</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card mt-2">
                      <div class="card-header-subsection card-header-subsection-alt">Styling</div>
                      <div class="card-body">
                        <div class="p-2 border rounded bg-white">
                          <!-- Loop for existing styles with trackBy -->
                          <div *ngFor="let item of (field.styles | keyvalue); trackBy: trackByStyleKey"
                            class="row align-items-center mb-2">
                            <div class="col-5">
                              <!-- Key is readonly. -->
                              <input type="text" class="form-control" [value]="item.key" readonly
                                [name]="'styleKey' + i + item.key">
                            </div>
                            <div class="col-5">
                              <!-- Value is editable. -->
                              <input type="text" class="form-control" [(ngModel)]="field.styles[item.key]"
                                [name]="'styleValue' + i + item.key">
                            </div>
                            <div class="col-2">
                              <!-- remove button: style -->
                              <button type="button" class="btn btn-danger btn-sm"
                                (click)="removeStyle(field, item.key)">Remove</button>
                            </div>
                          </div>
                          <!-- Row for adding a new style -->
                          <div class="row align-items-center">
                            <div class="col-5">
                              <input type="text" class="form-control" [(ngModel)]="field['_newStyleKey']"
                                placeholder="Style key" (keydown.enter)="addPendingStyle(field)"
                                [name]="'newStyleKey' + i">
                            </div>
                            <div class="col-5">
                              <input type="text" class="form-control" [(ngModel)]="field['_newStyleValue']"
                                placeholder="Style value" (blur)="addPendingStyle(field)"
                                (keydown.enter)="addPendingStyle(field)" [name]="'newStyleValue' + i">
                            </div>
                            <div class="col-2">
                              <button type="button" class="btn btn-primary btn-sm" (click)="addPendingStyle(field)">
                                + Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card mt-2">
                      <div class="card-header-subsection card-header-subsection-alt">Regular Expression</div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="row align-items-center">
                              <div class="col-md-4"><label class="form-label mb-0">Regex Match Pattern</label></div>
                              <div class="col-md-8"><input type="text" class="form-control"
                                  [(ngModel)]="field.regexReplacement.matchPattern" [name]="'matchPattern' + i"></div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="row align-items-center">
                              <div class="col-md-4"><label class="form-label mb-0">Regex Replacement</label></div>
                              <div class="col-md-8"><input type="text" class="form-control"
                                  [(ngModel)]="field.regexReplacement.replacement" [name]="'replacement' + i"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- EV Channels Section -->
      <div class="card mb-0">
        <div class="card-header d-flex justify-content-between align-items-center" (click)="toggleSection('evChannels')"
          style="cursor:pointer;">
          <div class="d-flex align-items-center">
            <h5 class="m-0 d-flex align-items-center">
              <span class="icon-container me-2">
                <i class="pi pi-chevron-right" [class.rotated]="!evChannelsCollapsed"></i>
              </span>
              Ev Channels
            </h5>
            <i class="pi pi-info-circle ms-2 text-dark" title="Ev Channels: "></i>
          </div>
          <button type="button" class="btn btn-success btn-sm" (click)="addNewChannel(); $event.stopPropagation()">+ Add
            New Channel</button>
        </div>
        <div *ngIf="!evChannelsCollapsed">
          <div class="card-body">
            <div *ngIf="!configData.evChannels.length" class="text-center text-muted">No channels defined.</div>
            <div class="row">
              <!-- Left Column -->
              <div class="col-md-6 ev-channel-col ev-channel-col-left">
                <div class="row align-items-center channel-data-row mb-2 fw-bold" *ngIf="leftChannels.length > 0">
                  <div class="col-md-2"><label class="form-label">Channel</label></div>
                  <div class="col-md-3"><label class="form-label">Type</label></div>
                  <div class="col-md-6"><label class="form-label">Description</label></div>
                  <div class="col-md-1 text-center"><label class="form-label">Enabled</label> </div>

                </div>
                <div *ngFor="let channel of leftChannels; let i = index; let odd = odd"
                  class="row align-items-center channel-data-row mb-2" [ngClass]="{'row-odd': odd}">
                  <div class="col-md-2">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="channel.channelName"
                      [name]="'channelNameL' + i" placeholder="Channel Name">
                  </div>
                  <div class="col-md-3">
                    <select class="form-select form-select-sm" [(ngModel)]="channel.channelType"
                      [name]="'channelTypeL' + i">
                      <option *ngFor="let type of channelTypes" [value]="type">{{type}}</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="channel.channelDescription"
                      [name]="'channelDescL' + i" placeholder="Description"></textarea>
                  </div>
                  <div class="col-md-1 text-center">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="channel.enabled"
                      [name]="'channelEnabledL' + i">
                    <button  type="button" class="btn btn-danger btn-sm"
                            (click)="removeChannel(configData.evChannels.indexOf(channel))"><i
                      class="pi pi-times"></i></button>
                  </div>

                </div>
              </div>
              <!-- Right Column -->
              <div class="col-md-6 ev-channel-col ev-channel-col-right">
                <div class="row align-items-center channel-data-row mb-2 fw-bold" *ngIf="rightChannels.length > 0">
                  <div class="col-md-2"><label class="form-label">Channel</label></div>
                  <div class="col-md-3"><label class="form-label">Type</label></div>
                  <div class="col-md-6"><label class="form-label">Description</label></div>
                  <div class="col-md-1 text-center"><label class="form-label">Enabled</label></div>
                </div>
                <div *ngFor="let channel of rightChannels; let i = index; let odd = odd"
                  class="row align-items-center channel-data-row mb-2" [ngClass]="{'row-odd': odd}">
                  <div class="col-md-2">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="channel.channelName"
                      [name]="'channelNameR' + i" placeholder="Channel Name">
                  </div>
                  <div class="col-md-3">
                    <select class="form-select form-select-sm" [(ngModel)]="channel.channelType"
                      [name]="'channelTypeR' + i">
                      <option *ngFor="let type of channelTypes" [value]="type">{{type}}</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="channel.channelDescription"
                      [name]="'channelDescR' + i" placeholder="Description"></textarea>
                  </div>
                  <div class="col-md-1 text-center">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="channel.enabled"
                      [name]="'channelEnabledR' + i">
                    <button type="button" class="btn btn-danger btn-sm"
                      (click)="removeChannel(configData.evChannels.indexOf(channel))"><i
                        class="pi pi-times"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Mappings Section -->
      <div class="card mb-0">
        <div class="card-header d-flex justify-content-between align-items-center" (click)="toggleSection('mappings')"
          style="cursor:pointer;">
          <div class="d-flex align-items-center">
            <h5 class="m-0 d-flex align-items-center">
              <span class="icon-container me-2">
                <i class="pi pi-chevron-right" [class.rotated]="!mappingsCollapsed"></i>
              </span>
              Ev Channel Field Groups
            </h5>
            <i class="pi pi-info-circle ms-2 text-dark"
              title="Configuration Set: where you group Channels and Fields"></i>
          </div>
          <button type="button" class="btn btn-success btn-sm" (click)="addNewMapping(); $event.stopPropagation()">+ Add
            New Ev Channel Field Groups</button>
        </div>
        <div *ngIf="!mappingsCollapsed">
          <div class="card-body subtab">
            <div *ngIf="!configData.evChannelFieldGroups || !configData.evChannelFieldGroups.length" class="text-center text-muted">No Ev Channel Field Groups defined.
            </div>

            <!-- Collapsible card for each mapping -->
            <div *ngFor="let mapping of configData.evChannelFieldGroups; let i = index" class="card">
              <div class="card-header-subsection d-flex justify-content-between align-items-center ev-channel-fields-item-header"
                (click)="toggleMappingCollapse(mapping)" style="cursor:pointer;">
                <div class="d-flex align-items-center">
                  <h5 class="m-0 d-flex align-items-center">
                    <span class="icon-container me-2">
                      <i class="pi pi-chevron-right" [class.rotated]="!mapping.collapsed"></i>
                    </span>
                    Ev Channel Field Group: {{i + 1}}
                  </h5>
                  <i class="pi pi-info-circle ms-2 text-dark"
                    title="Configuration Set: where you group Channels and Fields"></i>
                </div>
                <div class="d-flex align-items-center">
                  <button type="button" class="btn btn-danger btn-sm me-2"
                    (click)="removeMapping(i); $event.stopPropagation()">Delete Ev Channel Field Group</button>
                  <!-- Move Up/Down Buttons -->
                  <button type="button" class="btn btn-outline-secondary btn-sm me-2"
                    (click)="moveMappingUp(i); $event.stopPropagation()" [disabled]="i === 0" title="Move Up">
                    <i class="pi pi-arrow-up"></i>
                  </button>
                  <button type="button" class="btn btn-outline-secondary btn-sm me-2"
                    (click)="moveMappingDown(i); $event.stopPropagation()"
                    [disabled]="i === configData.evChannelFieldGroups.length - 1" title="Move Down">
                    <i class="pi pi-arrow-down"></i>
                  </button>

                  <!-- Enabled Switch -->
                  <div class="form-check form-switch me-2" (click)="$event.stopPropagation()">
                    <input class="form-check-input" type="checkbox" role="switch" [(ngModel)]="mapping.enabled"
                      [name]="'mappingEnabled' + i">
                    <label class="form-check-label">Enabled</label>
                  </div>

                </div>
              </div>

              <!-- This div controls the visibility of the mapping's content -->
              <div *ngIf="!mapping.collapsed">
                <div class="card-body">
                  <div class="row align-items-stretch">
                    <div class="col-md-6 p-2 field-group-divider">
                      <div class="row align-items-center">
                        <div class="col-10 d-flex align-items-center">
                          <h6 class="m-0">Channel References</h6>
                          <i class="pi pi-info-circle ms-2 text-dark"
                            title="Channel reference from EV channels section"></i>
                        </div>
                        <div class="col-2">
                          <button type="button" class="btn btn-success btn-sm"
                            (click)="addNewChannelRef(mapping); $event.stopPropagation()">+ Add Channel</button>
                        </div>
                      </div>
                      <!-- Section 1: Channel References -->
                      <div>
                        <div *ngIf="!mapping.evChannelRefs.length" class="text-center text-muted p-1">No channel mapped.
                        </div>
                        <!-- Header Row -->
                        <div *ngIf="mapping.evChannelRefs.length" class="row align-items-center">
                          <div class="col-3"><label class="form-label">Channel</label></div>
                          <div class="col-3"><label class="form-label">Comparison</label></div>
                          <div class="col-3 d-flex align-items-center"><label class="form-label mb-0">Method</label>
                            <i class="pi pi-info-circle ms-2 text-dark" [pTooltip]="accountFetchMethodHelp"
                              [escape]="false" tooltipPosition="top" tooltipStyleClass="account-fetch-method-tooltip"></i>
                          </div>
                          <div class="col-1 text-center"><label class="form-label">Enabled</label></div>
                          <div class="col-2 text-center"><label class="form-label">Actions</label></div>
                        </div>
                        <!-- Data Rows -->
                        <div *ngFor="let ref of mapping.evChannelRefs; let refIndex = index; let odd = odd"
                          class="row align-items-center channel-data-row compact-row" [ngClass]="{'row-odd': odd}">
                          <div class="col-3">
                            <select class="form-select form-select-sm" [(ngModel)]="ref.channelName"
                              [name]="'mapChannelName' + i + refIndex">
                              <option *ngFor="let ch of configData.evChannels" [value]="ch.channelName">
                                {{ch.channelName}}
                              </option>
                            </select>
                          </div>
                          <div class="col-3">
                            <select class="form-select form-select-sm" [(ngModel)]="ref.channelComparisonType"
                              [name]="'mapChannelComp' + i + refIndex">
                              <option *ngFor="let type of channelComparisonTypes" [value]="type">{{type}}</option>
                            </select>
                          </div>
                          <div class="col-3">
                            <select class="form-select form-select-sm" [(ngModel)]="ref.method"
                              [name]="'mapChannelMethod' + i + refIndex">
                              <option *ngFor="let type of accountFetchMethods" [value]="type">{{type}}</option>
                            </select>
                          </div>
                          <div class="col-1 text-center">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="ref.enabled"
                              [name]="'mapChannelRefEnabled' + i + refIndex">
                          </div>
                          <div class="col-2 text-center">
                            <button type="button" class="btn btn-danger btn-sm"
                              (click)="removeChannelRef(mapping, refIndex)"><i class="pi pi-times"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 p-2">
                      <div class="row align-items-center">
                        <div class="col-8 d-flex align-items-center">
                          <h6 class="m-0">Field References</h6>
                          <i class="pi pi-info-circle ms-2 text-dark"
                            title="Field reference from EV fields section"></i>
                        </div>
                        <div class="col-4 text-center">
                          <button type="button" class="btn btn-success btn-sm"
                            (click)="addNewFieldRef(mapping); $event.stopPropagation()">+ Add Field</button>
                        </div>
                      </div>
                      <!-- Section 2: Fields on EV page -->
                      <div>
                        <div *ngIf="!mapping.evFieldRefs.length" class="text-center text-muted p-1">No fields mapped.
                        </div>
                        <!-- Header Row -->
                        <div *ngIf="mapping.evFieldRefs.length" class="row align-items-center">
                          <div class="col-4"><label class="form-label">Field Name</label></div>
                          <div class="col-4"><label class="form-label">Usage</label></div>
                          <div class="col-4 text-center"><label class="form-label">Actions</label></div>
                        </div>

                        <!-- Data Rows -->
                        <div *ngFor="let fieldRef of mapping.evFieldRefs; let fieldRefIndex = index; let odd = odd"
                          class="row align-items-center channel-data-row" [ngClass]="{'row-odd': odd}">

                          <!-- Field Name Dropdown -->
                          <div class="col-4">
                            <select class="form-select form-select-sm" [(ngModel)]="fieldRef.fieldName"
                              [name]="'fieldRefName' + i + fieldRefIndex">
                              <option *ngFor="let field of configData.evFields" [value]="field.fieldName">
                                {{field.fieldName}}</option>
                            </select>
                          </div>

                          <!-- Usage Dropdown -->
                          <div class="col-4">
                            <select class="form-select form-select-sm" [(ngModel)]="fieldRef.fieldUsage"
                              [name]="'fieldRefUsage' + i + fieldRefIndex">
                              <option *ngFor="let usage of fieldUsageTypes" [value]="usage">{{usage}}</option>
                            </select>
                          </div>

                          <!-- Actions -->
                          <div class="col-4 d-flex justify-content-center align-items-center">
                            <button type="button" class="btn btn-outline-secondary btn-sm"
                              (click)="moveFieldRefUp(mapping, fieldRefIndex)" [disabled]="fieldRefIndex === 0"
                              title="Move Up">
                              <i class="pi pi-arrow-up"></i>
                            </button>
                            <button type="button" class="btn btn-outline-secondary btn-sm ms-2"
                              (click)="moveFieldRefDown(mapping, fieldRefIndex)"
                              [disabled]="fieldRefIndex === mapping.evFieldRefs.length - 1" title="Move Down">
                              <i class="pi pi-arrow-down"></i>
                            </button>
                            <button type="button" class="btn btn-danger btn-sm ms-2"
                              (click)="removeFieldRef(mapping, fieldRefIndex)"><i class="pi pi-times"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Save Section -->
      <div class="card mb-0" style="border-radius: 0.0rem !important;">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-auto">
              <label for="changeDescription" class="form-label mb-0">Change Description</label>
            </div>
            <div class="col">
              <input id="changeDescription" type="text" class="form-control" [(ngModel)]="changeDescription"
                placeholder="Describe your changes" />
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-primary" (click)="saveConfig()">Save Changes</button>
            </div>
          </div>
        </div>
      </div>


    </p-card>
  </div>



</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="email-sms-template"></p-confirmDialog>
